import {Component, OnInit, Input} from '@angular/core';
import {FormulaireService} from 'src/app/saisie/formulaire.service';
import {LibellesService} from 'src/app/core/libelles.service';
import {FiltreService} from '../../filtre.service';
import {UntypedFormControl} from '@angular/forms';
import {IntegerInputComponent} from "../integer-input/integer-input.component";
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
    selector: 'bis-integer-inline-input',
    templateUrl: './integer-inline-input.component.html',
    styleUrls: ['../input/input.component.css']
})
export class IntegerInlineInputComponent extends IntegerInputComponent implements OnInit {
    @Input()
    classeSupplLabel: string = 'text-right';
    @Input()
    classeSupplInput: string = '';
    
    constructor(
        protected formulaireService: FormulaireService,
        protected libelleService: LibellesService,
        protected filtreService: FiltreService,
        public modeRenduService: ModeRenduService
    ) {
        super(formulaireService, libelleService, filtreService, modeRenduService);
    }

    /** Retourne le FormControl servant à l’affichage qui n’est plus le même que le FormControl d’origine */
    get formAffichage(): UntypedFormControl {
        return this.currentControl.parent.get(this.labelAffichage) as UntypedFormControl;
    }

    /** Label à affecter au FormControl servant à l’affichage */
    get labelAffichage(): string {
        return this.label + '_affichage';
    }

    ngOnInit() {
        super.ngOnInit();
    }

    /** Besoin de réécrire cette fonction pour travailler sur le champ visible à l’écran */
    champTouche() {
        return this.formAffichage.touched;
    }
}
